module.exports = __webpack_public_path__ + "img/tupperware.342d70e4.png";